import {Component, inject, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {ModalData} from '@interfaces/modal-data';

@Component({
  selector: 'app-modals-dialog',
  imports: [MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatButtonModule],
  standalone: true,
  templateUrl: './modals-dialog.component.html',
  styleUrl: './modals-dialog.component.scss'
})
export class ModalsDialogComponent {

  public dataModule: ModalData;
  private dialogRef: MatDialogRef<ModalsDialogComponent> = inject(MatDialogRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: ModalData) {
    this.dataModule = data;
  }

  close(): void {
    this.dialogRef.close();
  }

}
